import RootModel from './root';

const ChannelStat = new RootModel({
	path: 'channelstats',
});

export default ChannelStat;
